/**
 * All about Scroll utils
 * @namespace Scroll
 */


export default class Scroll {
    /**
     * Scroll to top
     * @param {Number} distance distance from top view, by default is 0
     * @param {DOM} element element you want to target the scrolling, by default is window
     */
    static scrollTop({distance = 0, element = null} = {}) {
        if(!element) element = window;

        element.scroll(0, distance);
    }
}